import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Tags.scss';

/** Renders an array of tags */

const Tags = props => {
  const { color, tags } = props;
  return (
    <div className="tags">
      {tags.map((tag, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Badge color={color} key={i}>
          {typeof tag === 'string' ? (
            tag
          ) : (
            <React.Fragment>
              {tag.icon && <FontAwesomeIcon icon={tag.icon} className="mr-1" />}
              {tag.label}
            </React.Fragment>
          )}
        </Badge>
      ))}
    </div>
  );
};

Tags.propTypes = {
  /** Bootstrap colors, sets the background color */
  color: PropTypes.oneOf([
    'default',
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
  ]),
  /** An array of strings (tags) */
  tags: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]).isRequired,
};

Tags.defaultProps = {
  color: 'secondary',
};

export default Tags;
